/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_931Inputs */

const cs_ares_legal_form_931 = /** @type {(inputs: Ares_Legal_Form_931Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evropská společnost`)
};

const en_ares_legal_form_931 = /** @type {(inputs: Ares_Legal_Form_931Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European company`)
};

/**
* | output |
* | --- |
* | "European company" |
*
* @param {Ares_Legal_Form_931Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_931 = /** @type {((inputs?: Ares_Legal_Form_931Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_931Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_931(inputs)
	return cs_ares_legal_form_931(inputs)
});